module.exports = "../dist/img/img_1-23.98b5.jpg";